// import React, { useCallback, useEffect, useMemo, useState } from "react";
// import "./CashBook.css";
// import { Download } from "lucide-react";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
// import axios from "axios";
// import { toast } from "react-toastify";

// const API_URL = "https://payyug.in/api";
// const CashBook = () => {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [ledger,setLedger]=useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [cashBookData, setCashBookData] = useState([]);
//   const [branchLedgerList,setBranchLedgerList]=useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [hasSearched, setHasSearched] = useState(false);
//   const { profile } = useSelector((state) => state.userProfile);
//   const dispatch = useDispatch();

//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);


//   const fetchBranchLedgers=async()=>{
//     try{
//       const res = await axios.get(
//         ` https://payyug.in/api/branch-ledger/get-all`,
//         {
//           params: {
//             superAdminId:profile?.superAdminId,
//             limit: 1000,
//             status: "Active",
//           },
//         }
//       )

//       setBranchLedgerList(res?.data?.data||[])
//     }catch(err){
//       toast.error(err?.response?.data?.message||"Something went wrong!")
//     }
//   }

//   useEffect(()=>{
//     if(!profile?.superAdminId) return;
//     fetchBranchLedgers()
//   },[profile?.superAdminId])

//   const fetchCashBookData = useCallback(async () => {
//     if (!fromDate || !toDate) return;

//     try {
//       setLoading(true);
//       setError("");

//       const token = localStorage.getItem("authToken");

//       const res = await axios.get(`${API_URL}/report/cash-book`, {
//         params: {
//           superAdminId: profile?.superAdminId,
//           branchId: profile?.branchId,
//           fromDate: fromDate,
//           toDate: toDate,
//           cashLedgerId: ledger,
//         },
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       setCashBookData(res?.data || []);
//       setCurrentPage(1);
//     } catch (err) {
//       console.error(err);
//       toast.error(err?.response?.data?.message || "Failed to fetch day book");
//       setError(err?.response?.data?.message || "Failed to fetch day book");
//     } finally {
//       setLoading(false);
//     }
//   }, [fromDate, toDate, profile]);

//   /* ================= FILTER ================= */
//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!fromDate) {
//       toast.warn("Please select From Date");
//       return;
//     }
//     if (!toDate) {
//       toast.warn("Please select To Date");
//       return;
//     }
//     setHasSearched(true);
//   };

//   /* ================= FETCH AFTER SEARCH ================= */
//   useEffect(() => {
//     if (hasSearched) fetchCashBookData();
//   }, [fetchCashBookData, hasSearched]);

//   return (
//     <>
//       <div className="cashBook-container">
//         <h1 className="cashBook-heading">Cash Book</h1>

//         {/* Overview Form Section */}
//         <section className="cashBook-top">
//           <form action="" className="cashBook-form" onSubmit={handleSubmit}>
//             <div className="cashBook-form-section">
//               <div className="cashBook-form-input-fields">
//                 <label>Select Ledger</label>
//                 <select name="ledger" value={ledger} onChange={(e)=>setLedger(e.target.value)
//                 }>
//                   <option value="">Select Ledger</option>
//                   {branchLedgerList.map((l)=>(
//                     <option key={l.id} value={l.id}>{l?.ledger?.name}</option>
//                   ))}
//                 </select>
//               </div>
//               <div className="cashBook-form-input-fields">
//                 <label>From Date</label>
//                 <input
//                   type="date"
//                   value={fromDate}
//                   onChange={(e) => setFromDate(e.target.value)}
//                 />
//               </div>
//               <div className="cashBook-form-input-fields">
//                 <label>To Date</label>
//                 <input
//                   type="date"
//                   value={toDate}
//                   onChange={(e) => setToDate(e.target.value)}
//                 />
//               </div>
//             </div>
//             <div className="cashBook-form-submit-btn">
//               <button type="submit">{loading ? "Loading..." : "Get Records"}</button>
//             </div>
//           </form>
//         </section>

//         {/* pdf download buttons */}
//         <div className="cashBook-pdf-download-btns">
//           <button>
//             <Download size={15} /> Print Cashbook
//           </button>
//           <button>
//             <Download size={15} /> Print Bankbook
//           </button>
//           <button>
//             <Download size={15} /> Print Cashbook & Bankbook
//           </button>
//         </div>

//         {/* Overview Report Section */}
//         <section className="cashBook-report">
//           <div className="cashBook-report-container">
//             {/* <p className="cashBook-report-heading">Cash Records</p> */}
//             <div className="cashBook-report-table">
//               <p className="cashBook-report-heading">Cash Records</p>

//               <div className="cashBook-report-table-div">
//                 <div className="cashBook-report-debit-table">
//                   <p>Debit</p>
//                   <table>
//                     <tr>
//                       <th>Particulars</th>
//                       <th>DR</th>
//                     </tr>
//                     <tr>
//                       <td>A</td>
//                       <td>Debit</td>
//                     </tr>
//                   </table>
//                 </div>
//                 <div className="cashBook-report-credit-table">
//                   <p>Credit</p>
//                   <table>
//                     <tr>
//                       <th>Particulars</th>
//                       <th>CR</th>
//                     </tr>
//                     <tr>
//                       <td>A</td>
//                       <td>Credit</td>
//                     </tr>
//                   </table>
//                 </div>
//               </div>
//               <p style={{ textAlign: "center", fontWeight: 600 }}>
//                 Opening Balance: {cashBookData?.openingBalance}
//               </p>
//             </div>
//           </div>
//           <div className="cashBook-report-container">
//             {/* <p className="cashBook-report-heading">Bank Records</p> */}
//             <div className="cashBook-report-table">
//               <p className="cashBook-report-heading">Bank Records</p>

//               <div className="cashBook-report-table-div">
//                 <div className="cashBook-report-debit-table">
//                   <p>Debit</p>
//                   <table>
//                     <tr>
//                       <th>Particulars</th>
//                       <th>DR</th>
//                     </tr>
//                     <tr>
//                       <td>A</td>
//                       <td>Debit</td>
//                     </tr>
//                   </table>
//                 </div>
//                 <div className="cashBook-report-credit-table">
//                   <p>Credit</p>
//                   <table>
//                     <tr>
//                       <th>Particulars</th>
//                       <th>CR</th>
//                     </tr>
//                     <tr>
//                       <td>A</td>
//                       <td>Credit</td>
//                     </tr>
//                   </table>
//                 </div>
//               </div>
//               <p style={{ textAlign: "center", fontWeight: 600 }}>
//                 Closing Balance: {cashBookData?.closingBalance}
//               </p>
//             </div>
//           </div>
//         </section>
//       </div>
//     </>
//   );
// };

// export default CashBook;






import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./CashBook.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
import axios from "axios";
import { toast } from "react-toastify";

const API_URL = "https://payyug.in/api";

const CashBook = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const ITEMS_PER_PAGE_OPTIONS = [10, 20, 50,100];

  const [ledger, setLedger] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [openingBalance,setOpeningBalance]=useState("");
  const [closingBalance,setClosingBalance]=useState("");

  const [cashBookData, setCashBookData] = useState([]);
  const [branchLedgerList, setBranchLedgerList] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [hasSearched, setHasSearched] = useState(false);

  const { profile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  // Fetch ledgers when profile metadata is ready
  const fetchBranchLedgers = useCallback(async () => {
    try {
      const res = await axios.get(`${API_URL}/branch-ledger/get-all`, {
        params: {
          superAdminId: profile?.superAdminId,
          limit: 1000,
          status: "Active",
        },
      });
      setBranchLedgerList(res?.data?.data || []);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong!");
    }
  }, [profile?.superAdminId]);

  useEffect(() => {
    if (profile?.superAdminId) {
      fetchBranchLedgers();
    }
  }, [profile?.superAdminId, fetchBranchLedgers]);

  // Fetch system records
  const fetchCashBookData = useCallback(async () => {
    if (!fromDate || !toDate) return;

    try {
      setLoading(true);
      setError("");

      const token = localStorage.getItem("authToken");
      const res = await axios.get(`${API_URL}/report/cash-book`, {
        params: {
          superAdminId: profile?.superAdminId,
          branchId: profile?.branchId,
          fromDate: fromDate,
          toDate: toDate,
          cashLedgerId: ledger,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setOpeningBalance(res?.data?.openingBalance)
      setClosingBalance(res?.data?.closingBalance)
      const dataPayload = res?.data?.data || res?.data || [];
      setCashBookData(dataPayload);
      setCurrentPage(1);
    } catch (err) {
      console.error(err);
      const errMsg = err?.response?.data?.message || "Failed to fetch cash book records";
      toast.error(errMsg);
      setError(errMsg);
    } finally {
      setLoading(false);
    }
  }, [fromDate, toDate, ledger, profile]);

  /* ================= FILTER ================= */
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!fromDate) {
      toast.warn("Please select From Date");
      return;
    }
    if (!toDate) {
      toast.warn("Please select To Date");
      return;
    }
    setHasSearched(true);
    fetchCashBookData();
  };

  /* ================= CLIENT SIDE SEARCH + PAGINATION ================= */
  const filteredData = useMemo(() => {
    if (!cashBookData || !Array.isArray(cashBookData)) return [];
    return cashBookData.filter((item) =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
    );
  }, [cashBookData, searchQuery]);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage) || 1;

  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    return filteredData.slice(startIndex, startIndex + itemsPerPage);
  }, [filteredData, currentPage, itemsPerPage]);

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  return (
    <div className="cashBook-container">
      <h1 className="cashBook-heading">Cash Book Management</h1>

      {/* Overview Form Section */}
      <section className="cashBook-top">
        <form className="cashBook-form" onSubmit={handleSubmit}>
          <div className="cashBook-form-section">
            <div className="cashBook-form-input-fields">
              <label htmlFor="ledger-select">Select Ledger</label>
              <select
                id="ledger-select"
                name="ledger"
                value={ledger}
                onChange={(e) => setLedger(e.target.value)}
              >
                <option value="">All Cash Ledgers</option>
                {branchLedgerList.map((l) => (
                  <option key={l.id || l._id} value={l.id || l._id}>
                    {l?.ledger?.name || l.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="cashBook-form-input-fields">
              <label htmlFor="from-date">From Date</label>
              <input
                id="from-date"
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>
            <div className="cashBook-form-input-fields">
              <label htmlFor="to-date">To Date</label>
              <input
                id="to-date"
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>
          </div>
          <div className="cashBook-form-submit-btn">
            <button type="submit" disabled={loading}>
              {loading ? "Loading..." : "Get Records"}
            </button>
          </div>
        </form>
      </section>

      {/* Data Presentation Area */}
      {hasSearched && (
        <div className="cashbook-report-container">
          <h2>Cash Book Records & Summary</h2>
          
          <div className="cashbook-report-filter-div">
            <input
              type="text"
              className="search-input"
              placeholder="Search statements..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />

            <div className="cashbook-report-filter">
              <label>Show </label>
              <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
                {ITEMS_PER_PAGE_OPTIONS.map((num) => (
                  <option key={num} value={num}>
                    {num}
                  </option>
                ))}
              </select>
              <span> entries</span>
            </div>
          </div>

          {error && <p className="error-message-banner">{error}</p>}

          <div className="cashbook-report-table-container">
            <table className="cashbook-report-table">
              <thead>
                <tr>
                  <th>SN</th>
                  <th>Voucher No</th>
                  <th>Voucher Type</th>
                  <th>Date</th>
                  <th>Debit (In)</th>
                  <th>Credit (Out)</th>
                  <th>Balance</th>
                  <th>Opening Balance</th>
                  <th>Closing Balance</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((item, index) => (
                    <tr key={item.id || item._id || index}>
                      <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                      <td>{item.voucherNo || "N/A"}</td>
                      <td>{item.voucherType || "N/A"}</td>
                      <td>{item?.date?new Date(item?.date).toLocaleDateString("en-GB"): "N/A"}</td>
                      <td className="amount-debit">{item.debit ? `₹${item.debit}` : "0.00"}</td>
                      <td className="amount-credit">{item.credit ? `₹${item.credit}` : "0.00"}</td>
                      <td className="amount-balance"><strong>₹{item.balance ?? "0.00"}</strong></td>
                      <td className="amount-balance"><strong>₹{openingBalance ?? "0.00"}</strong></td>
                      <td className="amount-balance"><strong>₹{closingBalance ?? "0.00"}</strong></td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="no-results-td">
                      No logs or statement entries match the criteria.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination Component Controls */}
          {filteredData.length > itemsPerPage && (
            <div className="cashbook-report-pagination-div">
              <button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              >
                ⬅ Prev
              </button>

              <span>
                Page <strong>{currentPage}</strong> of {totalPages}
              </span>

              <button
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              >
                Next ➡
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CashBook;